import { cn } from "cn";
import { BwPlayFill } from "@/components/ui/icons";

/**
 * The round play mark centred on a video's poster, so a video never reads as a
 * still image. It scales with the picture it sits on — a quarter of its width,
 * kept between 16px and 28px.
 */
export function AttachmentPlayMark() {
  return (
    <span
      className={cn(
        /* sorted */
        "absolute top-1/2 left-1/2 flex",
        "items-center justify-center",
        "w-1/4 min-w-4 max-w-7 aspect-square",
        "bg-bg-dark-max border border-border-light-high rounded-full shadow-md",
        "-translate-x-1/2 -translate-y-1/2",
        "pointer-events-none",
      )}
    >
      <BwPlayFill className="text-text-light size-3/4" />
    </span>
  );
}
